import { HttpService, L10nBase, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface PaymentMethodItem {
    readonly associatedWithBankAccount: boolean;
    readonly id: number;
    readonly cashPayment: boolean;
    readonly deferredPayment: boolean;
    readonly dueDate: number;
    readonly translationKey: string;
    readonly name: string;
}

interface PaymentMethodInternalItem {
    readonly associatedWithBankAccount: boolean;
    readonly cashPayment: boolean;
    readonly deferredPayment: boolean;
    readonly dueDateDays: number;
    readonly id: number;
    readonly name: string;
    readonly translationKey: string;
}

export class PaymentMethodBaseQuery extends Query<PaymentMethodItem[]> { }

export class PaymentMethodBaseQueryHandlerBase implements QueryHandler<PaymentMethodBaseQuery, PaymentMethodItem[]> {
    private static Url = TaggedUrl.join('system/paymentMethods', [Tags.Api]);

    public constructor(
        private readonly http: HttpService,
        private readonly translate: L10nBase) {}

    public async handleAsync(_: PaymentMethodBaseQuery): Promise<PaymentMethodItem[]> {
        const { data } = await this.http.get<{ items: PaymentMethodInternalItem[] }>(PaymentMethodBaseQueryHandlerBase.Url);
        return data.items.map(i => ({
            associatedWithBankAccount: i.associatedWithBankAccount,
            cashPayment: i.cashPayment,
            deferredPayment: i.deferredPayment,
            dueDate: i.dueDateDays,
            translationKey: i.translationKey,
            id: i.id,
            name: this.translate.instant(`business.payment-method.${i.translationKey}.name`),
        }));
    }
}
